import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { attachNotificationTapHandler } from "@/lib/notifications";
import { setupPushNotifications } from "@/lib/push";

// Mounts once at the App root. Wires native notification taps -> React Router navigation,
// and asks for push permission once the user is signed in.
export default function NotificationBridge() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const userId = user?.user_id;

  useEffect(() => {
    attachNotificationTapHandler((route) => navigate(route));
  }, [navigate]);

  useEffect(() => {
    if (!userId) return;
    // Short delay so the prompt appears over the app, not mid-transition from the sign-in sheet.
    const t = setTimeout(() => setupPushNotifications((route) => navigate(route)), 1500);
    return () => clearTimeout(t);
  }, [userId, navigate]);

  return null;
}
